function getCollapsedDayColumns(daysInMonth: number): number[] {
  const days: number[] = [];

  for (let day = 1; day <= daysInMonth; day += 2) {
    days.push(day);
  }

  return days;
}

export function getVisibleDayColumns(
  daysInMonth: number,
  isExpanded: boolean,
  _isCompact: boolean
): number[] {
  if (isExpanded) {
    return Array.from({ length: daysInMonth }, (_, index) => index + 1);
  }

  return getCollapsedDayColumns(daysInMonth);
}

export function getMonthSectionWidthPx(
  daysInMonth: number,
  isExpanded: boolean,
  isCompact: boolean,
  dayWidthPx: number
): number {
  const visibleDays = getVisibleDayColumns(daysInMonth, isExpanded, isCompact);
  return visibleDays.length * dayWidthPx;
}
